/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: cbu.js
 */
$.namespace('SCS.cbu');

/**
 * Initialize CBU customer callout on login
 */
var user = undefined;
var userBox = undefined;
require('lib/personalization/profile').getProfile().then(function(profile) {
	// Wait for DOMContentLoaded
	$(function ready() {
		userBox = require('lib/personalization/Tc.Module.UserBox').getGlobalUserBox();
		user = profile.getUser();
		if(!user) {
			return;
		}
		if (user.isSegmentCbu()) {
			SCS.cbu.initOrderButtons();
		}
	});
});


/**
 * Initialize order buttons for CBU customers.
 * I.e. don't allow ordering products and show a dialog.
 */
SCS.cbu.initOrderButtons = function() {
	$('.scs-product-orderbutton-buy, .scs-product-orderbutton-notify').each(function() {
		// override click events with this handler
		$(this).off('click').click(function(e) {
			e.preventDefault();
			SCS.cbu.PRODUCT_ID = SCS.cbu.getProductId($(this));
			SCS.cbu.createOrderBarrierDialog();
			return false;
		});
	});
};

/**
 * Get product id from corresponding order button
 * @param orderButton Order button
 */
SCS.cbu.getProductId = function(orderButton) {
	return orderButton.closest('form').find('input[name=productId]').val();
};

/**
 * Create CBU order dialog ('do not order ...')
 */
SCS.cbu.createOrderBarrierDialog = function() {
	var cbuEl = $('#cbuTemplate').tmpl();
	var msg = SCS.portal.tplToString(cbuEl);
	SCS.cbu.orderDialog = $('<div>' + msg + '</div>').dialog({
		title: cbuEl.data('dialog-title'),
		classes: {'ui-dialog': 'cbu'},
		width: 500,
		buttons: [
			{
				text: cbuEl.data('btn-cancel'),
				'class': 'secondary-button',
				click: function() {
					SCS.cbu.orderDialog.dialog('close');
				}
			},
			{
				text: cbuEl.data('btn-continue'),
				'class': 'primary-button',
				click: SCS.cbu.continueHandler
			}
		]
	});
	SCS.portal.applyAfterEffects();
};

/**
 * Click on the 'continue' button in the CBU options dialog
 */
SCS.cbu.continueHandler = function() {
	var values = $('#scs-cbu-order-form').serializeArray();
	if (values && values[0] && values[0]['value']) {
		var option = values[0]['value'];
		if (option == 'tocbushop') {
			location.href = userBox.getCbuShopUrl();
		}
		else if (option == 'loginascbu') {
			SCS.ecommerce.setRedirectCookie(userBox.getLoginUrl());
			location.href = userBox.getLogoutUrl();
		}
		else if (option == 'shopasguest') {
			location.href = userBox.getLogoutUrl();
		}
	}
	return false;
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/cbu.js
// module id = 260
// module chunks = 0